module.exports = __webpack_public_path__ + "img/qr_code_google_play_store.8c669a83.png";